// Formatting shared by the insights panel tabs.

export function tagName(tag) {
	if (!tag) return "Unassigned";
	return String(tag)
		.split("-")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ");
}

// A look-ahead or half-life in seconds, in the largest unit that keeps it readable.
export function durationLabel(seconds) {
	if (!(seconds > 0)) return "–";
	if (seconds < 60) return `${round1(seconds)} s`;
	if (seconds < 3600) return `${round1(seconds / 60)} min`;
	if (seconds < 86400) return `${round1(seconds / 3600)} h`;
	const days = round1(seconds / 86400);
	return days === 1 ? "1 day" : `${days} days`;
}

function round1(value) {
	return Math.round(value * 10) / 10;
}

export function score(value) {
	return typeof value === "number" && isFinite(value) ? value.toFixed(1) : "0.0";
}

export function signed(value) {
	if (typeof value !== "number" || !isFinite(value) || Math.abs(value) < 0.05) return "";
	return `${value > 0 ? "+" : "−"}${Math.abs(value).toFixed(1)}`;
}

export function clockTime(ms) {
	const d = new Date(ms);
	const pad = (n, w = 2) => String(n).padStart(w, "0");
	return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.${pad(d.getMilliseconds(), 3)}`;
}

// Props shown inline in the log; long values are cut so one event stays one line.
export function propsSummary(props) {
	if (!props || typeof props !== "object") return "";
	return Object.keys(props)
		.map((key) => {
			let value = props[key];
			if (value !== null && typeof value === "object") value = JSON.stringify(value);
			value = String(value);
			return `${key}=${value.length > 40 ? value.slice(0, 39) + "…" : value}`;
		})
		.join("  ");
}

export function whole(value) {
	return typeof value === "number" && isFinite(value) ? Math.round(value) : 0;
}

// Plain words for a 0-100 career score, so testers read a level, not a formula.
export function strength(value) {
	if (!(value > 0)) return "Not counted yet";
	if (value >= 60) return "Strong";
	if (value >= 30) return "Growing";
	return "Early";
}

// One colour per profile area, shared by the profile and decay tabs.
export const AREA_COLORS = {
	career: "#20639b",
	recent: "#4a7eff",
	momentum: "#038e00",
	assessment: "#e0a21f",
	sections: "#596c98",
	activity: "#72738e",
};

// The dashboard's top cards, as their tiles label them.
export const TOP_CARD_NAMES = {
	buildresume: "Build Resume",
	interviewprep: "Interview Prep",
	takeasmnt: "Take Assessment",
	careerroadmap: "Career Roadmap",
	applyjobs: "Apply for Jobs",
	learnupskill: "Learn & Upskill",
};

export function cardName(key) {
	return TOP_CARD_NAMES[key] || String(key || "");
}
